import React, { useContext } from 'react';

import { useGeoConfig } from './useGeoConfig';
import { PostGeoConfig, PostGeoConfigLocation } from '../api/useGeoConfig/useGeoConfig';
import { ProfileErrorMessage } from '../ProfileErrorMessages';

export interface GeoConfigContextInterface {
  selectProfile: PostGeoConfig | undefined;
  setSelectProfile: React.Dispatch<React.SetStateAction<PostGeoConfig | undefined>>;
  selectPin: PostGeoConfigLocation | undefined;
  setSelectPin: React.Dispatch<React.SetStateAction<PostGeoConfigLocation | undefined>>;
  editingPin: PostGeoConfigLocation | undefined;
  setEditingPin: React.Dispatch<React.SetStateAction<PostGeoConfigLocation | undefined>>;
  creatingNewProfile: boolean;
  setCreatingNewProfile: React.Dispatch<React.SetStateAction<boolean>>;
  modifyingExistingProfile: boolean;
  setModifyingExistingProfile: React.Dispatch<React.SetStateAction<boolean>>;
  tempGeoConfigs: PostGeoConfig[];
  setTempGeoConfigs: React.Dispatch<React.SetStateAction<PostGeoConfig[]>>;
  initialGeoConfig: PostGeoConfig[];
  setInitialGeoConfig: React.Dispatch<React.SetStateAction<PostGeoConfig[]>>;
  lastSavedTempGeoConfig: PostGeoConfig[];
  setLastSavedTempGeoConfig: React.Dispatch<React.SetStateAction<PostGeoConfig[]>>;
  errorMessage: ProfileErrorMessage;
  setErrorMessage: React.Dispatch<React.SetStateAction<ProfileErrorMessage>>;
  geoConfigProfileNames: string[];
  selectProfileIndex: number;
  selectPinIndex?: number;
  editingPinIndex?: number;
  updateTempGeoConfigPin(location: PostGeoConfigLocation): void;
  onLongChange(e: React.ChangeEvent<HTMLInputElement>): void;
  onRadiusChange(value: number[]): void;
  onLatChange(e: React.ChangeEvent<HTMLInputElement>): void;
}

interface GeoConfigProviderProps {
  children: React.ReactNode;
  dealerId?: number;
}

const GeoConfigContext = React.createContext<GeoConfigContextInterface | undefined>(undefined);

export const GeoConfigProvider = ({ dealerId, children }: GeoConfigProviderProps) => {
  const value = useGeoConfig({ dealerId });

  return <GeoConfigContext.Provider value={value}>{children}</GeoConfigContext.Provider>;
};

export function useGeoConfigContext() {
  const context = useContext(GeoConfigContext);
  if (!context) {
    throw new Error('useGeoConfigContext must be used within a GeoConfigProvider');
  } else {
    return context;
  }
}
